<template>
    <div v-if="visible">
        <div class="avatar-cover position-relative" @click="$emit('btnClick')" v-if="!loading">
            <el-avatar :icon="icon" :size="avatarSize" fit="none" class="avatar-btn" data-toggle="tooltip"
                       :title="title"></el-avatar>
            <div v-if="showCorner" class="position-absolute cornerIcon">
                <i class="fa text-success" :class="cornerIcon" aria-hidden="true"></i>
            </div>
        </div>
        <div class="spinner-border text-secondary avatar-cover" role="status" v-if="loading">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "AvatarButton",
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        visible: {
            type: Boolean,
            default: true
        },
        icon: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: ''
        },
        showCorner: {
            type: Boolean,
            default: false
        },
        cornerIcon: {
            type: String,
            default: 'fa-lock'
        },
        avatarSize: {
            type: Number,
            default: 25
        }
    }
}
</script>

<style scoped>
.avatar-cover {
    margin: 0.1rem;
    width: 25px;
    height: 25px;
}

.avatar-btn {
    color: #fff;
    background-color: #6c757d;
    border-color: #6c757d;
}

.avatar-btn:hover {
    color: #fff;
    background-color: #5a6268;
    border-color: #5a6268;
}

.avatar-btn:active {
    box-shadow: 0 0 0 0.2rem rgb(192, 196, 200);
}

.cornerIcon {
    right: 0;
    top: -0.4rem;
    z-index: 200;
}
</style>